import { useContext } from "react";
import { GlobalContext } from "../util/globalContext";

export function useOrganizationApi() {
const { config } = useContext(GlobalContext);
const BASE_URL = config?.REACT_APP_BASE_URL || "http://localhost:3000"
// ✅ Utility to get headers with token
function getAuthHeaders() {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    "X-token": token || "",
  };
}

// ✅ Get all vendor organizations with pagination, search, and filters
async function getAllVendorOrg({ limit = 5, offset = 0, search = "", ...filters } = {}) {
  const body = {
    limit,
    offset,
    ...(search ? { search } : {}),
    ...filters, // include other filter fields if provided
  };

  const response = await fetch(`${BASE_URL}/get_all_vendor_org`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to fetch organizations");
  }

  return data;
}

// ✅ Create a vendor organization
async function createVendorOrg(orgData) {
  const response = await fetch(`${BASE_URL}/create_vendor_org`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(orgData),
  });

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to create organization");
  }

  return data;
}

// ✅ Delete vendor organization
async function deleteVendorOrg(_id) {
  const response = await fetch(`${BASE_URL}/delete_vendor_org/${_id}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to delete organization");
  }

  return data;
}

// ✅ Get organization by ID
async function getVendorOrgById(id) {
  const response = await fetch(`${BASE_URL}/get_vendor_org/${id}`, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to fetch organization");
  }

  return data.data;
}

// ✅ Update organization
async function updateVendorOrg(id, updateData) {
  const response = await fetch(`${BASE_URL}/update_vendor_org/${id}`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify(updateData),
  });

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to update organization");
  }

  return data;
}
// ✅ Get all vendor organizations + direct customers for filter dropdown
async function getAllVendorOrgAndCustomers() {
  const response = await fetch(`${BASE_URL}/get_all_vendor_org_and_customers`, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to fetch organizations and customers");
  }

  // ✅ RETURN FULL OBJECT (not data.data)
  return data; 
}

 // ✅ RETURN ALL FUNCTIONS
  return {
    getAllVendorOrg,
    createVendorOrg,
    deleteVendorOrg,
    getVendorOrgById,
    updateVendorOrg,
    getAllVendorOrgAndCustomers
  };

}